import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class JiraServicedesk {
  private baseUrl = 'https://pkisigning.atlassian.net';

  constructor(private http: HttpClient) {}

  private serviceDeskId = '2'; // Service Desk ID for Jira Service Desk
  private requestTypeId = '154'; // Request Type ID for Jira Service Desk

  createSupportTicket(summary: string, 
                      description: string, 
                      email: string,
                      phoneNumber: number, 
                      requestId: string = "", 
                      url: string, 
                      organisation: string = "",
                      attachments: any[] = [],
                      cclist: string[] = []) {
    let ticketBody =
    {
      serviceDeskId: this.serviceDeskId,
      requestTypeId: this.requestTypeId, // Request Type ID for Jira Service Desk 
      raiseOnBehalfOf: email, // user email
      requestFieldValues: {
        "summary": summary, // Title of the ticket, prefixed with environment (DEV/TEST/ACC/PROD)
        "description": description, // Description of the issue, provided by the user
        "attachment": attachments,
        "customfield_10027": cclist, //cc list, currently empty as we don't have this functionality in the frontend
        "customfield_10039": this.getJiraDateFormat(), //current date and time formatted dd-mm-yyyyThh:mm
        "customfield_10040": url, //current page url
        "customfield_10042": phoneNumber, //user phone number
        "customfield_10215": organisation, //organisation, currently empty as we don't have this functionality in the frontend
        "customfield_10214": this.getBrowserName(), //browser used, nu alleen de browsernaam
        "customfield_10216": requestId, //GUID, currently generated in the frontend as we don't have this functionality in the backend
        "customfield_10213": this.getPrettyOS() //operating system
        // ...customFields
      }
    }

    return this.createTicket(ticketBody);
  }

  createAttachments(formData: FormData) {
    return this.http.post(environment.apiUrl + "/jira/attachments", formData);
  }

  createTicket(ticketBody: any) {
    return this.http.post(environment.apiUrl + "/jira/ticket", {
      body: JSON.stringify(ticketBody)
    });
  }


  private getJiraDateFormat(): string {
    const date = new Date();
    const tz = 'Europe/Amsterdam';
    const pad = (n: number) => n < 10 ? '0' + n : n;
    const y = date.toLocaleString('en-GB', { timeZone: tz, year: 'numeric' });
    const m = pad(+date.toLocaleString('en-GB', { timeZone: tz, month: '2-digit' }));
    const d = pad(+date.toLocaleString('en-GB', { timeZone: tz, day: '2-digit' }));
    const h = pad(+date.toLocaleString('en-GB', { timeZone: tz, hour: '2-digit', hour12: false }));
    const min = pad(+date.toLocaleString('en-GB', { timeZone: tz, minute: '2-digit' }));
    const temp = new Date(Date.UTC(+y, +m - 1, +d, +h, +min));
    const offset = Math.round((temp.getTime() - date.getTime()) / 60000);
    const sign = offset >= 0 ? '+' : '-';
    const absOffset = Math.abs(offset);
    const offsetHours = pad(Math.floor(absOffset / 60));
    const offsetMins = pad(absOffset % 60);
    return `${y}-${m}-${d}T${h}:${min}:00.000${sign}${offsetHours}${offsetMins}`;
  }

  private getPrettyOS(): string {
    const platform = navigator.platform.toLowerCase();
    const ua = navigator.userAgent.toLowerCase();
    if (platform.includes('win')) return 'Windows';
    if (platform.includes('mac')) return 'MacOS';
    if (platform.includes('linux')) return 'Linux';
    if (/android/.test(ua)) return 'Android';
    if (/iphone|ipad|ipod/.test(ua)) return 'iOS';
    return 'Onbekend';
  }

  /**
   * Returns only the browser name (Chrome, Edge, Firefox, Safari, Opera, Unknown)
   */
  private getBrowserName(): string {
    const ua = navigator.userAgent;
    if (/Edg\//.test(ua)) return 'Edge';
    if (/OPR\//.test(ua)) return 'Opera';
    if (/Chrome\//.test(ua)) return 'Chrome';
    if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari';
    if (/Firefox\//.test(ua)) return 'Firefox';
    return 'Onbekend';
  }
}

// #Region Bug - #19 Bug report template
// {
//     "requestTypeFields": [
//         {
//             "fieldId": "summary",
//             "name": "Samenvatting",
//             "description": "",
//             "required": true,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "system": "summary"
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "description",
//             "name": "Waarmee kunnen we je helpen? Geef zoveel mogelijk informatie",
//             "description": "",
//             "required": true,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "system": "description"
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "attachment",
//             "name": "Voeg alle relevante bestanden bij",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "array",
//                 "items": "attachment",
//                 "system": "attachment"
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "customfield_10027",
//             "name": "Request participants",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "array",
//                 "items": "user",
//                 "custom": "com.atlassian.servicedesk:sd-request-participants",
//                 "customId": 10027
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "customfield_10215",
//             "name": "Organisation",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "custom": "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
//                 "customId": 10215
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "customfield_10214",
//             "name": "Browser used",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "custom": "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
//                 "customId": 10214
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "customfield_10216",
//             "name": "GUID",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "custom": "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
//                 "customId": 10216
//             },
//             "visible": true
//         },
//         {
//             "fieldId": "customfield_10213",
//             "name": "Operating system",
//             "description": "",
//             "required": false,
//             "defaultValues": [],
//             "validValues": [],
//             "jiraSchema": {
//                 "type": "string",
//                 "custom": "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
//                 "customId": 10213
//             },
//             "visible": true
//         }
//     ],
//     "canRaiseOnBehalfOf": true,
//     "canAddRequestParticipants": true
// }